import { Button, Heading, Icon, IconButton, Input, InputGroup, InputRightElement, Select, Stack, Table, TableContainer, Tbody, Td, Text, Th, Thead, Tr } from "@chakra-ui/react";


import { BsExclamationLg } from "react-icons/bs";
import { FaArrowLeft, FaArrowRight, FaSearch } from "react-icons/fa";


export default function TempDisconnectedEntities() {
    
    return (
        <Stack w={'full'} justify={"center"} align={"center"} spacing={6}>
            <Stack
                direction={{ base: 'column', md: 'column', lg: 'column', xl: 'row' }}
                justify={'space-between'}
                boxShadow={'base'}
                rounded={'xl'}
                w={'98%'}
                p={4}
                spacing={{ base: 6, md: 6, lg: 6, xl: 0 }}
            >
                <Stack
                    align={'flex-start'}
                    justify={'start'}
                    spacing={4}
                >
                    <Stack direction={'row'}>
                        <Icon
                            as={BsExclamationLg}
                            fontSize={'5xl'}
                            color={'primary.400'}
                        />
                        <Stack spacing={1}>
                            <Heading fontSize={'xl'}>Temp Disconnected Entities</Heading>
                            <Text fontSize={'sm'}>Here you can view temp disconnected entities list.</Text>
                        </Stack>
                    </Stack>
                </Stack>
                <Stack
                    spacing={4}
                    justify={'end'}
                    direction={'row'}
                    align={{ lg: 'flex-start', xl: 'flex-end' }}
                >
                    <Stack direction={'row'} spacing={2}>
                        <InputGroup size={'sm'}>
                            <Input placeholder='Search' />
                            <InputRightElement children={<FaSearch color={'#ababab'} />} />
                        </InputGroup>
                        <Input
                            type="date"
                            size={'sm'}
                        />
                    </Stack>
                    <Button
                        size={'sm'}
                        color={'white'}
                        bg={'gray.400'}
                        _hover={{ bg: 'gray.500' }}
                        _active={{ bg: 'gray.600' }}
                    >
                        Resolved
                    </Button>
                </Stack>
            </Stack>

            <Stack boxShadow={'base'} rounded={'xl'} w={'98%'} p={4} spacing={4}>
                <TableContainer h={'sm'} overflowY={'scroll'}>
                    <Table size='sm'>
                        <Thead position={'sticky'} top={'0%'} h={'50px'} bg={'primary.400'} alignItems={'flex-start'}>
                            <Tr>
                                <Th
                                    isNumeric
                                    color={"white"}
                                >
                                    ID
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Business Name
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Owner Email
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Account Software
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    External Business Name
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Current Sync Status
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Last Update Date
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Error Details
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Status
                                </Th>
                            </Tr>
                        </Thead>
                        <Tbody>
                            <Td
                                colSpan={9}
                                bg={'gray.100'}
                                textAlign={'center'}
                            >
                                <Text>No data available in table.</Text>
                            </Td>
                        </Tbody>
                    </Table>
                </TableContainer>
                <Stack
                    direction={'row'}
                    justify={"space-between"}
                    align={'center'}
                >
                    <Text>Showing 5 of 10 results</Text>
                    <Stack direction={'row'} spacing={4}>
                        <Select placeholder="Select Rows Per Page">
                            <option selected>5 Per Page</option>
                            <option>10 Per Page</option>
                            <option>25 Per Page</option>
                            <option>50 Per Page</option>
                        </Select>
                        <Stack direction={'row'}>
                            <IconButton
                                aria-label="Previous"
                                icon={<FaArrowLeft />}
                                rounded={'full'}
                            />
                            <IconButton
                                aria-label="Previous"
                                icon={<FaArrowRight />}
                                rounded={'full'}
                            />
                        </Stack>
                    </Stack>
                </Stack>
            </Stack>
        </Stack >
    )
}